var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"compared-axis"},[_c('div',{staticClass:"compared-axis-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_vm._l((_vm.getRow),function(row,i){return _c('ComparedRow',{key:i,attrs:{"name":row.name,"color":row.color,"value":row.value}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }